export default "__VITE_ASSET__DFzHJQ_p__"